import { styled } from '@mui/material/styles';
import { IndentedSections } from '@openx/components-core/lib/IndentedSection/IndentedSections';
import type { VideoFormState, VideoOption } from '@openx/types/targeting/video';
import { noop } from '@openx/utils/noop';
import type { Dispatch, JSX, SetStateAction } from 'react';
import { DimensionChipLine } from '../../shared/DimensionChip/DimensionChipLine';
import { Items } from '../Items';

const StyledWrapper = styled('div')`
  padding-left: ${({ theme }) => theme.spacing(1.5)};
`;

type PlacementAndFormatProps = {
  placementAndFormat: (typeof VideoOption.PLACEMENT | typeof VideoOption.PRESENTATION_FORMAT)[];
  params: VideoFormState;
  updateParams?: Dispatch<SetStateAction<VideoFormState>>;
  readonly: boolean;
  shouldAddDimensionLine: boolean;
  disabledReasonMessage?: string;
};

export function PlacementAndFormat({
  placementAndFormat,
  params,
  updateParams = noop,
  readonly,
  shouldAddDimensionLine,
  disabledReasonMessage,
}: PlacementAndFormatProps): JSX.Element {
  return (
    <>
      <IndentedSections dataTest="placement-and-format-or-container">
        <StyledWrapper>
          {placementAndFormat.map((type, index) => (
            <div key={type}>
              <Items
                params={params[type]}
                type={type}
                readonly={readonly}
                onChange={updateParams}
                disabledReasonMessage={disabledReasonMessage}
              />
              {index === 0 && <DimensionChipLine switchState isSubsection />}
            </div>
          ))}
        </StyledWrapper>
      </IndentedSections>
      {shouldAddDimensionLine && <DimensionChipLine />}
    </>
  );
}
